import { useEffect, useRef } from 'react';

type UseHeartbeatProps = {
  sendMessage: (message: string) => void;
  onConnectionLost: () => void;
  isConnectionOpen?: boolean;
};

export const useHeartbeat = ({
  sendMessage,
  onConnectionLost,
  isConnectionOpen,
}: UseHeartbeatProps) => {
  const heartbeatIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const heartbeatTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (isConnectionOpen) {
      startHeartbeat();
    } else {
      stopHeartbeat();
    }

    return () => {
      stopHeartbeat();
    };
  }, [isConnectionOpen]);

  const startHeartbeat = () => {
    heartbeatIntervalRef.current = setInterval(() => {
      sendMessage(
        JSON.stringify({
          jsonrpc: '2.0',
          id: 'CUSTOM_HELLO_MESSAGE',
          method: 'hello',
          params: { message: 'Hello world!' },
        }),
      );

      heartbeatTimeoutRef.current = setTimeout(() => {
        onConnectionLost();
      }, 10000);
    }, 30000);
  };

  const stopHeartbeat = () => {
    if (heartbeatIntervalRef.current) {
      clearInterval(heartbeatIntervalRef.current);
      heartbeatIntervalRef.current = null;
    }
    if (heartbeatTimeoutRef.current) {
      clearTimeout(heartbeatTimeoutRef.current);
      heartbeatTimeoutRef.current = null;
    }
  };

  const resetHeartbeatTimeout = () => {
    if (heartbeatTimeoutRef.current) {
      clearTimeout(heartbeatTimeoutRef.current);
      heartbeatTimeoutRef.current = null;
    }
  };

  return { resetHeartbeatTimeout };
};
